module.exports = __webpack_public_path__ + "img/Logo-Mandomedio-PDE.c708f46f.png";